import { IconButton } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const PasswordInputWrapper = styled.div`
  position: relative;
`;

const PasswordEyeIcon = styled(IconButton)`
  position: absolute;
  right: 14px;
  top: 9px;
  z-index: 1;
`;
const PasswordStrength = styled.button`
  background-color: var(--color-bg-body);
  border: none;
  color: var(--color-fg-weakest);
  cursor: pointer;
  outline: none;
  position: absolute;
  right: 44px;
  text-transform: capitalize;
  top: 12px;
  z-index: 1;
`;
const PasswordArea = styled.div`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
  text-align: left;

  ul {
    margin-left: 5px;
  }
`;

const PasswordAreaItem = styled.li`
  align-items: center;
  color: ${({ isValid }) => (isValid ? 'var(--color-success-default)' : 'var(--color-fg-weakest)')};
  display: flex;

  ${DEVICE.mobile.max} {
    font-size: 12px;
  }

  &::before {
    content: '${({ isValid }) => (isValid ? '✓' : '•')}';
    margin-right: 5px;
  }

  margin-bottom: 5px;
`;

const PasswordAreaItemList = styled.ul`
  list-style-type: '-';
  padding-left: 8px;
`;

const PasswordInput = styled.div``;

export {
  PasswordArea,
  PasswordAreaItem,
  PasswordAreaItemList,
  PasswordEyeIcon,
  PasswordInput,
  PasswordInputWrapper,
  PasswordStrength
};
